var file_upload_viewer_default = {
  "fontElementMap": "Fp48Q",
  "file_upload_container": "rpKRP",
  "file_upload_link": "_7QDkW",
  "file_upload_error_container": "tBe2R",
  "file_upload_file_info": "oBg1n",
  "file_upload_type_icon": "-k-Tj",
  "file_upload_status_icon_container": "fIkDT",
  "file_upload_status_icon": "vLV5Q",
  "file_upload_description": "M5BTD",
  "file_upload_name_container": "_-4162",
  "file_upload_name": "hB0bR",
  "file_upload_extension": "iJL9x",
  "file_loader_icon": "DbkMj",
  "file_upload_icon_frame": "hg1r0",
  "file_upload_icon_background": "f0AE-"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
